import { ReactElement } from 'react';
import { Route } from 'react-router';
import { SwitchWithNotFound } from '../../containers/SwitchWithNotFound';
import { NotFoundView } from '../../views/errors/NotFound.view';
import { CloudCostsHistoryView } from '../../views/home/user/CloudCostsHistory.view';
import { Home } from '../config/Home';

export const CloudCostsRoute = (): ReactElement => (
  <SwitchWithNotFound notFound={<NotFoundView />}>
    <Route path={Home.User.CloudCosts.History.Path}>
      <CloudCostsHistoryView />
    </Route>
  </SwitchWithNotFound>
);
